import {
  NOTIFICATION_CLOSE,
  NOTIFICATION_CLOSE_ON_CLICK,
  NOTIFICATION_MODAL_SHOW,
  NOTIFICATION_PAGE_SHOW,
} from '@common/actions/NotificationActions';

const initState = {
  modal: {
    show: false,
    name: null,
    extraArgs: {},
  },
  page: {
    show: false,
    name: null,
    extraArgs: {},
  },
};

const notificationReducer = (state = initState, action) => {
  switch (action.type) {
    case NOTIFICATION_PAGE_SHOW:
      return {
        ...state,
        page: {
          show: true,
          name: action.payload.name,
          extraArgs: action.payload.extraArgs,
        },
      };
    case NOTIFICATION_MODAL_SHOW:
      return {
        ...state,
        modal: {
          show: true,
          name: action.payload.name,
          extraArgs: action.payload.extraArgs,
        },
      };
    case NOTIFICATION_CLOSE:
      return initState;
    case NOTIFICATION_CLOSE_ON_CLICK:
      return initState;
    default:
      return state;
  }
};

export default notificationReducer;
